// @flow
import React, { Component } from "react";

import { ColorSchema } from "../../global/types/scss";
import SingleInlineEditor from "../component/SingleInlineEditor";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

type UserProfilePropsType = {
  conferenceFields: { [key: string]: *},
  user: { [key: string]: *},
  setUpdateError: Function
};

class UserProfile extends Component<UserProfilePropsType, *> {
  constructor(props: UserProfilePropsType) {
    super(props);
  }

  render(): React$Element<*> {
    const user = this.props.user;
    const conferenceFields = this.props.conferenceFields;
    const userFields = user && user.additional_person_fields;
    let extraline = null;
    if (conferenceFields.length > 0 && userFields) {
      extraline = conferenceFields.map((item: *, i: number) => {
        let menus = null;
        if (item.values) {
          menus = item.values.map((list: string) => ({ label: list, value: list }));
        }
        return (
          <TableRow key={i}>
            <TableCell padding="dense" className="border" style={{ color: ColorSchema("primary") }}>{item.name}</TableCell>
            <TableCell padding="dense" className="compact">
              <SingleInlineEditor
                value={userFields[item.name]}
                field={item.name}
                tooltip={"Click to change " + item.name + " value"}
                setUpdateError={this.props.setUpdateError}
                menus={menus}
                type={item.type}
              />
            </TableCell>
          </TableRow>
        );
      });
    }

    return (
      <Table className="app-table no-border">
        <TableBody>
          <TableRow>
            <TableCell padding="dense" className="border" style={{ color: ColorSchema("primary") }}>First Name</TableCell>
            <TableCell padding="dense" className="compact" style={!extraline ? { height: "60px" } : {}}>
              <SingleInlineEditor value={user.first_name} field="first_name" tooltip="Click to change First Name" setUpdateError={this.props.setUpdateError} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell padding="dense" className="border" style={{ color: ColorSchema("primary") }}>Last Name</TableCell>
            <TableCell padding="dense" className="compact" style={!extraline ? { height: "60px" } : {}}>
              <SingleInlineEditor value={user.last_name} field="last_name" tooltip="Click to change Last Name" setUpdateError={this.props.setUpdateError} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell padding="dense" className="border" style={{ color: ColorSchema("primary") }}>Organisation / Company</TableCell>
            <TableCell padding="dense" className="compact" style={!extraline ? { height: "60px" } : {}}>
              <SingleInlineEditor value={user.organisation} field="organisation" tooltip="Click to change Organisation Name" setUpdateError={this.props.setUpdateError} />
            </TableCell>
          </TableRow>
          {extraline}
        </TableBody>
      </Table>
    );
  };
}

export default UserProfile;


// WEBPACK FOOTER //
// ./src/conference/component/UserProfile.js